import extendedFieldHooks from "ExtendedFields/selectorHooks";
import FnrTypography from "FnrTypography/FnrTypography";

import FnrDeleteButton from "UI/FnrDeleteButton/FnrDeleteButton";
import FnrTooltip from "UI/FnrTooltip2";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap/FnrVerticalGap";

const Content = ({ isSignupVariant, title, isInSmartGroup }) => {
  if (isInSmartGroup) {
    return (
      <>
        <FnrTypography color="textLight" bold>
          This field must be removed from any Smart Groups before it can be
          deleted.
        </FnrTypography>
      </>
    );
  }
  if (isSignupVariant) {
    return (
      <>
        <FnrTypography color="textLight" bold>
          Are you sure you want to remove this field from this Signup item?
        </FnrTypography>
        <FnrTypography color="textLight">
          {`Previously collected profile field data will remain on user’s
          profiles.`}
        </FnrTypography>
      </>
    );
  }
  return (
    <>
      <FnrTypography color="textLight">
        Are you sure you want to remove <strong>{title}</strong> from your
        members&apos; profiles?
      </FnrTypography>
      <FnrTypography color="textLight" bold>
        You will lose any responses members have made on this field.
      </FnrTypography>
    </>
  );
};

const DeleteButton = () => {
  const [loading, deleteExtendedField] =
    extendedFieldHooks.useDeleteExtendedField();
  const [title] = extendedFieldHooks.useTitle();
  const [fieldData] = extendedFieldHooks.useFieldData();
  const isSignupVariant = extendedFieldHooks.useVariant() === "signup";
  const [isUsedBySmartGroup] = extendedFieldHooks.useIsUsedBySmartGroup();
  const [notDeletable] = extendedFieldHooks.useNotDeletable();

  if (isUsedBySmartGroup) {
    return (
      <FnrTooltip
        maxWidth="200px"
        content="This field is used by a Smart Group and cannot be deleted."
      >
        <FnrDeleteButton disabled onClick={() => {}} />
      </FnrTooltip>
    );
  }

  if (notDeletable) {
    return (
      <FnrTooltip
        maxWidth="200px"
        content="This field is shared by your parent network and cannot be deleted."
      >
        <FnrDeleteButton disabled onClick={() => {}} />
      </FnrTooltip>
    );
  }

  return (
    <FnrDeleteButton
      loading={loading}
      onClick={deleteExtendedField}
      confirmText={
        <FnrVerticalGap data-cy="ExtendedFields_DeleteConfirm">
          <Content
            isSignupVariant={isSignupVariant}
            title={title}
            isInSmartGroup={fieldData.isInSmartGroup}
          />
        </FnrVerticalGap>
      }
      disableConfirmButton={fieldData.isInSmartGroup}
      cancelButtonText={fieldData.isInSmartGroup ? "Ok" : undefined}
      hideConfirmButton={fieldData.isInSmartGroup}
    />
  );
};

export default DeleteButton;
